var pk_promana = 'pk_live_AgVy5M1pzZMRYqzkeqrfjS4x';

var reloadableErrors = [
    'payment_intent_unexpected_state',
];

var clientSecret;

var Ecom = function(){

    var _setupIntent = function(){
        Do.Ajax('/payment-intent',{});
    }

    var _setSecret = function(r){
        clientSecret = r.s;
    }

    var _updateAndNotify = function (args) {
    
        var symbol_el = $('#promana-cart-icon');
        var count_el  = $('#promana-cart-count');
        if(args.count == 0){
            count_el.remove();
        }else{
            if( ! count_el.length){
                symbol_el.after('<span id="promana-cart-count" class="badge badge-success badge-pill ml-auto ml-lg-0">'+args.count+'</span>');
                count_el  = $('#promana-cart-count');
            }else{
                count_el.html(args.count);
            }
            Ecom.setupIntent();
        }
    
        Do.Notify(args);
        $('.lms-checkout').removeClass('d-none');
        $('.lms-add-cart').addClass('d-none');
    
    }

    return {
        setupIntent: function(){
            _setupIntent();
        },
        setSecret: function(r){
            _setSecret(r);
        },
        updateAndNotify: function(a){
            _updateAndNotify(a);
        },
        setSecret: function(r){
            _setSecret(r);
        },
    }

}();

$(document).ready( function() {

    if($("#card-element").length){
        var card = elements.create("card", { style: style });
        card.mount("#card-element");
        Ecom.setupIntent();

        card.on('change', ({error}) => {
            let displayError = document.getElementById('card-errors');
            if (error) {
                displayError.textContent = error.message;
            } else {
                displayError.textContent = '';
            }
        });

        $('#pay-button').on('click', function(ev) {
            ev.preventDefault();
            stripe.confirmCardPayment(clientSecret, {
                payment_method: {
                    card: card,
                    // billing_details: {
                    //     name: 'Jenny Rosen'
                    // }
                }
            }).then(function(result) {
                if (result.error) {
                    Do.Notify({
                        title: '',
                        content: stripeError[result.error.code],
                        class: 'warning',
                        delay: 1000
                    });
                    if( $.inArray( result.error.code, reloadableErrors ) != -1 ){
                        setTimeout( function () {location.href = '/cart';},1000);
                    }
                } else {
                    if (result.paymentIntent.status === 'succeeded') {
                        Do.Notify({
                            content: successMessage,
                            class: 'success',
                            title: '',
                            delay: 5000,
                        });
                        Do.Ajax( "/empty-cart",{
                            route: '/my/assignments/todo' 
                        });
                    }
                }
            });
        });

    }

    $('.promana-add-cart').on('click', function(){
        Do.Ajax( "/add-to-cart",{
            p:$(this).data('p'),
            i:$(this).data('i'),    
        });
    });

    $('#promana-empty-cart').on('click', function(){
        Do.Ajax("/empty-cart",{});
    });

    $('.promana-assign').on('click', function(){
        Do.Ajax( "/assign",{
            u: $(this).attr('id')
        });
    });

    $('.promana-remove-from-cart').on('click', function(){
        Do.Ajax( "/remove-from-cart",{
            u: $(this).attr('id')
        });
        $('#cart-item-'+$(this).attr('id')).fadeOut(300, function (){
            $(this).remove();
        });
    });

});
